<template>
	<tbody class="table-totals-body">
		<tr>
			<td colspan="8" style="border: 0;height: 16px;"></td>
		</tr>
		<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
			<td class="no-left-border" style="vertical-align: top;" colspan="3" rowspan="5">
				<div class="my-2">
					<p class="font-weight-bold mb-0">Total Tablas Combinadas</p>
					<p class="caption mb-0">Esta sección incluye los totales combinados de la tabla general y sus anexos.</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" colspan="2">
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[4]">
				<div>
					<p class="mb-0 text-right caption" >UF</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[5]">
				<div>
					<p class="mb-0 text-right caption" >CLP</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[6]" class="no-right-border"></td>
		</tr>
		<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
			<td class="no-left-border" style="vertical-align: middle;height: auto;height: auto;" colspan="2">
				<p class="text-right mb-0 font-weight-bold">Total Neto</p>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[4]">
				<div>
					<p class="text-right mb-0 font-weight-bold body-1">{{ totalProjectCostSummary.total_cost_uf | toThousandFilter(2) }}</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[5]">
				<div>
					<p class="text-right mb-0 font-weight-bold body-1">${{ totalProjectCostSummary.total_cost_clp | toThousandFilter }}</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[6]" class="no-right-border"><p class="text-right mb-0 font-weight-bold caption"></p></td>
		</tr>
		<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
			<td class="no-left-border" style="vertical-align: middle;height: auto;" colspan="2"><p class="text-right mb-0 font-weight-bold">Impuesto ({{ costsTable.tax?.value }}%)</p></td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[4]">
				<div>
					<p class="text-right mb-0 font-weight-bold body-1">{{ totalProjectCostSummary.tax_value_uf | toThousandFilter(2) }}</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[5]">
				<div>
					<p class="text-right mb-0 font-weight-bold body-1">${{ totalProjectCostSummary.tax_value_clp | toThousandFilter }}</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[6]" class="no-right-border"><p class="text-right mb-0 font-weight-bold caption"></p></td>
		</tr>
		<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
			<td class="no-left-border" style="vertical-align: middle;height: auto;" colspan="2"><p class="text-right mb-0 font-weight-bold">Total con Impuesto</p></td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[4]">
				<div>
					<p class="text-right mb-0 font-weight-bold body-1">{{ totalProjectCostSummary.total_cost_uf_taxed | toThousandFilter(2) }}</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[5]">
				<div>
					<p class="text-right mb-0 font-weight-bold body-1">${{ totalProjectCostSummary.total_cost_clp_taxed | toThousandFilter }}</p>
				</div>
			</td>
			<td style="vertical-align: middle;height: auto;" :width="colWidths[6]" class="no-right-border"><p class="text-right mb-0 font-weight-bold caption"></p></td>
		</tr>
	</tbody>
</template>

<script>
import { getParentItemTotalValueMultiWithTax } from '@/helpers/tablecostHelpers.js'

export default {
	props: {
		costsTable: {
			type: Object,
			required: true
		},
		colors: {
			type: Object,
			required: true
		},
    colWidths: {
      type: Array,
      default: () => ['30%','10%','10%','15%','12%','15%','8%']
    },
	},
	computed: {
		totalProjectCostSummary() {
			const mainSections = [
				this.costsTable.surfaces,
				{items: this.costsTable.items},
				...this.costsTable.stages,
				...this.costsTable.specialties,
				...this.costsTable.projects,
				this.costsTable.reception
			].filter(Boolean);

			const mainTotals = getParentItemTotalValueMultiWithTax(mainSections, this.costsTable.tax || 0, this.costsTable.uf_value?.uf_value || 0);

			let subTotals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0,
				tax_value_uf: 0,
				tax_value_clp: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp_taxed: 0
			};

			if (Array.isArray(this.costsTable.project_tables)) {
				for (const subTable of this.costsTable.project_tables) {
					const subSections = [
						subTable.surfaces,
						{items: subTable.items},
						...subTable.stages,
						...subTable.specialties,
						...subTable.projects,
						subTable.reception
					].filter(Boolean);

					const subResult = getParentItemTotalValueMultiWithTax(subSections, subTable.tax || 0,  subTable.uf_value?.uf_value || 0);

					subTotals.qty += subResult.qty;
					subTotals.unit_cost_uf += subResult.unit_cost_uf;
					subTotals.unit_cost_clp += subResult.unit_cost_clp;
					subTotals.total_cost_uf += subResult.total_cost_uf;
					subTotals.total_cost_clp += subResult.total_cost_clp;
					subTotals.tax_value_uf += subResult.tax_value_uf;
					subTotals.tax_value_clp += subResult.tax_value_clp;
					subTotals.total_cost_uf_taxed += subResult.total_cost_uf_taxed;
					subTotals.total_cost_clp_taxed += subResult.total_cost_clp_taxed;
				}
			}

			return {
				qty: mainTotals.qty + subTotals.qty,
				unit_cost_uf: mainTotals.unit_cost_uf + subTotals.unit_cost_uf,
				unit_cost_clp: mainTotals.unit_cost_clp + subTotals.unit_cost_clp,
				total_cost_uf: mainTotals.total_cost_uf + subTotals.total_cost_uf,
				total_cost_clp: mainTotals.total_cost_clp + subTotals.total_cost_clp,
				tax_value_uf: mainTotals.tax_value_uf + subTotals.tax_value_uf,
				tax_value_clp: mainTotals.tax_value_clp + subTotals.tax_value_clp,
				total_cost_uf_taxed: mainTotals.total_cost_uf_taxed + subTotals.total_cost_uf_taxed,
				total_cost_clp_taxed: mainTotals.total_cost_clp_taxed + subTotals.total_cost_clp_taxed
			};
		}
	},
	methods: {
    calcFontColor(backgroundColor) {
      if (!backgroundColor) return '#000';
      let hex = backgroundColor.replace('#', '');
      if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? '#000' : '#fff';
    },
		detailTotalCostSummary(costsTable) {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;
			
			if (costsTable.surfaces && Array.isArray(costsTable.surfaces.items)) {
				for (const item of costsTable.surfaces.items) {
					const qty = parse(item.qty);
					const uf = parse(item.unit_cost_uf);
					const clp = parse(item.unit_cost_clp);

					totals.qty += qty;
					totals.unit_cost_uf += uf;
					totals.unit_cost_clp += clp;
					totals.total_cost_uf += uf * qty;
					totals.total_cost_clp += clp * qty;
				}
			}

			if (Array.isArray(costsTable.items)) {
				for (const item of costsTable.items) {
					if (Array.isArray(item.subitems) && item.subitems.length) {
						for (const sub of item.subitems) {
							const qty = parse(sub.qty);
							const uf = parse(sub.unit_cost_uf);
							const clp = parse(sub.unit_cost_clp);

							totals.qty += qty;
							totals.unit_cost_uf += uf;
							totals.unit_cost_clp += clp;
							totals.total_cost_uf += uf * qty;
							totals.total_cost_clp += clp * qty;
						}
					} else {
						const qty = parse(item.qty);
						const uf = parse(item.unit_cost_uf);
						const clp = parse(item.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				}
			}

			return totals;
		},
		costAllProjectsTotalSummary(costsTable) {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			if (Array.isArray(costsTable.projects)) {
				costsTable.projects.forEach((project, index) => {
					const projectTotals = this.costProjectDetailTotalCostSummary(index);

					totals.qty += projectTotals.qty;
					totals.unit_cost_uf += projectTotals.unit_cost_uf;
					totals.unit_cost_clp += projectTotals.unit_cost_clp;
					totals.total_cost_uf += Math.round(projectTotals.total_cost_uf);
					totals.total_cost_clp += Math.round(projectTotals.total_cost_clp);
				});
			}

			return totals;
		},
		stageTotalCostSummary(costsTable) {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;

			if (Array.isArray(costsTable.stages)) {
				for (const stage of costsTable.stages) {
					if (!Array.isArray(stage.items)) continue;

					for (const item of stage.items) {
						if (Array.isArray(item.subitems) && item.subitems.length > 0) {
							for (const sub of item.subitems) {
								const qty = parse(sub.qty);
								const uf = parse(sub.unit_cost_uf);
								const clp = parse(sub.unit_cost_clp);

								totals.qty += qty;
								totals.unit_cost_uf += uf;
								totals.unit_cost_clp += clp;
								totals.total_cost_uf += uf * qty;
								totals.total_cost_clp += clp * qty;
							}
						} else {
							const qty = parse(item.qty);
							const uf = parse(item.unit_cost_uf);
							const clp = parse(item.unit_cost_clp);

							totals.qty += qty;
							totals.unit_cost_uf += uf;
							totals.unit_cost_clp += clp;
							totals.total_cost_uf += uf * qty;
							totals.total_cost_clp += clp * qty;
						}
					}
				}
			}

			return totals;
		},
		specialtiesTotalCostSummary(costsTable) {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;

			if (Array.isArray(costsTable.specialties)) {
				for (const specialty of costsTable.specialties) {
					const hasItems = Array.isArray(specialty.items) && specialty.items.length > 0;

					if (hasItems) {
						for (const item of specialty.items) {
							const hasSubitems = Array.isArray(item.subitems) && item.subitems.length > 0;

							if (hasSubitems) {
								for (const sub of item.subitems) {
									const qty = parse(sub.qty);
									const uf = parse(sub.unit_cost_uf);
									const clp = parse(sub.unit_cost_clp);

									totals.qty += qty;
									totals.unit_cost_uf += uf;
									totals.unit_cost_clp += clp;
									totals.total_cost_uf += uf * qty;
									totals.total_cost_clp += clp * qty;
								}
							} else {
								const qty = parse(item.qty);
								const uf = parse(item.unit_cost_uf);
								const clp = parse(item.unit_cost_clp);

								totals.qty += qty;
								totals.unit_cost_uf += uf;
								totals.unit_cost_clp += clp;
								totals.total_cost_uf += uf * qty;
								totals.total_cost_clp += clp * qty;
							}
						}
					} else {
						const qty = parse(specialty.qty);
						const uf = parse(specialty.unit_cost_uf);
						const clp = parse(specialty.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				}
			}

			return totals;
		},
		projectsTotalCostSummary(costsTable) {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;

			if (Array.isArray(costsTable.projects)) {
				for (const project of costsTable.projects) {
					const hasItems = Array.isArray(project.items) && project.items.length > 0;

					if (hasItems) {
						for (const item of project.items) {
							const hasSubitems = Array.isArray(item.subitems) && item.subitems.length > 0;

							if (hasSubitems) {
								for (const sub of item.subitems) {
									const qty = parse(sub.qty);
									const uf = parse(sub.unit_cost_uf);
									const clp = parse(sub.unit_cost_clp);

									totals.qty += qty;
									totals.unit_cost_uf += uf;
									totals.unit_cost_clp += clp;
									totals.total_cost_uf += uf * qty;
									totals.total_cost_clp += clp * qty;
								}
							} else {
								const qty = parse(item.qty);
								const uf = parse(item.unit_cost_uf);
								const clp = parse(item.unit_cost_clp);

								totals.qty += qty;
								totals.unit_cost_uf += uf;
								totals.unit_cost_clp += clp;
								totals.total_cost_uf += uf * qty;
								totals.total_cost_clp += clp * qty;
							}
						}
					} else {
						const qty = parse(project.qty);
						const uf = parse(project.unit_cost_uf);
						const clp = parse(project.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				}
			}

			return totals;
		},
		stagesTotalCost(costsTable){
			let total = 0;

			if (Array.isArray(costsTable.stages)) {
				for (const stage of costsTable.stages) {
					if (Array.isArray(stage.items)) {
						for (const item of stage.items) {
							total += (item.qty || 0) * (item.unit_cost_uf || 0);

							if (Array.isArray(item.subitems)) {
								for (const subitem of item.subitems) {
									total += (subitem.qty || 0) * (subitem.unit_cost_uf || 0);
								}
							}
						}
					}
				}
			}

			return total;
		},
		receptionTotalCostSummary(costsTable) {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;
			const round2 = (n) => Math.round(n * 100) / 100;

			const processItem = (item) => {
				const qty = parse(item.qty);
				const uf = parse(item.unit_cost_uf);
				const clp = parse(item.unit_cost_clp);

				totals.qty += qty;
				totals.unit_cost_uf += uf;
				totals.unit_cost_clp += clp;
				totals.total_cost_uf += uf * qty;
				totals.total_cost_clp += clp * qty;
			};

			if (costsTable.reception) {
				const reception = costsTable.reception;
				if (Array.isArray(reception.items)) {
					for (const item of reception.items) {
						processItem(item);

						if (Array.isArray(item.subitems)) {
							for (const sub of item.subitems) {
								processItem(sub);
							}
						}
					}
				}
				if (Array.isArray(reception.subitems) && reception.subitems.length) {
					for (const sub of reception.subitems) {
						processItem(sub);
					}
				}

				if (
					(!Array.isArray(reception.items) || !reception.items.length) &&
					(!Array.isArray(reception.subitems) || !reception.subitems.length)
				) {
					processItem(reception);
				}
			}

			return {
				qty: round2(totals.qty),
				unit_cost_uf: round2(totals.unit_cost_uf),
				unit_cost_clp: round2(totals.unit_cost_clp),
				total_cost_uf: round2(totals.total_cost_uf),
				total_cost_clp: round2(totals.total_cost_clp),
			};
		}
	}
}
</script>

<style scoped>
</style>